import { useCallback } from "react";

import axios from "axios";
import { PAD_SCENARIO_SERVICE_ADDRESS } from "constants/app.constants";
import { exportToExcel } from "utils/exportToExcel";

import { useProjectContext } from "components/project/projects/context";

import { Scenario } from "../models/scenario";
import { flattenScenarioData } from "../utils/scenarioHelpers";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

const useExportScenarios = () => {
  const { selectedProjectId } = useProjectContext();
  const exportScenarios = useCallback(async () => {
    const response = await axios.get<Scenario[]>(
      `${API_URL}/${selectedProjectId}/export`
    );
    const formattedData = flattenScenarioData(response.data);

    const dateNow = new Date().toDateString();

    exportToExcel(formattedData, `scenarios-export-${dateNow}.xlsx`);

    return response.data;
  }, [selectedProjectId]); // Add selectedProjectId as a dependency

  return { exportScenarios };
};

export default useExportScenarios;
